import Vue from 'vue';
import store from '../../store';
import recipeIngredienceTransformer from '../../transformers/recipeIngredience';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const recipeIngrediences = recipeIngredienceTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchPaginatedMaterials', { recipeIngrediences, pagination });
  resolve(recipeIngrediences);
};

const failed = (error, reject) => reject();

export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('production/recipe_ingredience', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipeIngredience/items.js